import _, { uniqueId } from "lodash";
import { useSetRecoilState } from "recoil";
import { building_product_errors, contract_bill_user_errors } from "src/api/public-types";
import { attachErrorMeta } from "src/utils/sentry/meta";
import { ErrorModalState, errorModalState } from "./atom";

export type ErrorModal = {
  errorCode?: string;
  errorMessage?: string;
  errorData?: any;
  statusCode?: number;
  errorList?: string[];
  errorSubList?: string[];
  align?: "center" | "left";
  /** 원본 에러 객체 */
  cause?: unknown;
  /** 여러 실패를 한 모달에 요약할 때 원본 에러 객체 목록 */
  causes?: unknown[];
};

export const findErrorCodeMessages = (errorCode: string | undefined) => {
  let errorMessage = "";
  if (errorCode !== undefined) {
    const findBuildingNProduct = building_product_errors.find((error: any) => error.errorCode === errorCode);
    if (findBuildingNProduct) {
      errorMessage = findBuildingNProduct.message;
    }
    const findedContractnBiiling = contract_bill_user_errors.find((error: any) => error.errorCode === errorCode);
    if (findedContractnBiiling) {
      errorMessage = findedContractnBiiling.message;
    }
  }

  return errorMessage;
};

export const useErrorModal = () => {
  const setErrorModals = useSetRecoilState<ErrorModalState[]>(errorModalState);

  // 에러모달 열기
  const openErrorModal = (errorModalParams: ErrorModal) => {
    // sentry 및 에러 전파를 위해 에러 객체 참조 변수는 클론하지 않음
    const { cause, causes = [], ...rest } = errorModalParams;
    const allCauses = [cause, ...causes].filter((item) => item !== undefined);

    // 에러 모달이 큐에 등록될 때, 해당 에러의 노출 경로를 마킹함
    allCauses.forEach((item) => attachErrorMeta(item, { ui: { surface: "modal" } }));

    let draft = _.cloneDeep(rest);
    if (draft.errorMessage === undefined) {
      draft.errorMessage = findErrorCodeMessages(draft.errorCode);
    }
    if (draft.errorCode) {
      const message = findErrorCodeMessages(draft.errorCode);

      if (message !== "") {
        draft.errorMessage = message;
      }
    }

    const newErrorModal = {
      id: uniqueId("error_modal_unique_id_"),
      isOpen: true,
      errorCode: draft.errorCode,
      errorMessage: draft.errorMessage,
      errorData: draft.errorData,
      statusCode: draft.statusCode,
      errorList: draft.errorList,
      errorSubList: draft.errorSubList,
      align: draft.align,
      causes: allCauses,
    };
    setErrorModals((errorModals: ErrorModalState[]) => {
      return [...errorModals, newErrorModal];
    });

    return newErrorModal;
  };

  // 마지막 에러모달 닫기
  const closeLastErrorModal = () => {
    setErrorModals((errorModals: ErrorModalState[]) => {
      const newErrorModals = [...errorModals];

      newErrorModals.pop();
      return newErrorModals;
    });
  };

  // 에러모달 닫기
  const closeErrorModal = (errorModalId: string) =>
    setErrorModals((errorModals: ErrorModalState[]) => errorModals.filter((errorModal) => errorModal.id !== errorModalId));

  // 에러모달 모두 닫기
  const closeAllErrorModal = () => setErrorModals(() => []);

  return { openErrorModal, closeErrorModal, closeAllErrorModal, closeLastErrorModal };
};
